/* unplugin-vue-components disabled */import script from "./header.vue?vue&type=script&lang=ts&setup=true"
export * from "./header.vue?vue&type=script&lang=ts&setup=true"

import "./header.vue?vue&type=style&index=0&id=dd59a2f6&lang=less&scoped=true"

import exportComponent from "D:\\HBuilderProjects\\quyizu-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd59a2f6"]])

export default __exports__